export type Channel = 'facebook' | 'twitter' | 'email' | 'whatsapp';
export const CHANNELS: readonly Channel[] = ['facebook', 'whatsapp', 'twitter', 'email'] as const;
